import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// ── Production Console Security ─────────────────────────────────────────────
// Suppress all console output in production builds to prevent information
// leakage (stack traces, API paths, internal state) from reaching end users.
// Errors are silently swallowed — use your error monitoring service (e.g.
// Sentry) for production error tracking instead.
if (process.env.NODE_ENV === "production") {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.warn = noop;
  console.error = noop;
  console.trace = noop;
  console.group = noop;
  console.groupEnd = noop;
  console.groupCollapsed = noop;
  console.table = noop;
  console.dir = noop;
  console.time = noop;
  console.timeEnd = noop;
  console.count = noop;
  console.assert = noop;
}
// ────────────────────────────────────────────────────────────────────────────

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
